
import Input from './src/Input';
import EAN from './src/EAN';
import InputNumber from './src/InputNumber';
import MultiSelect from './src/MultiSelect';
import Select from './src/Select';
import DateInput from './src/DateInput';
import Iban from './src/Iban';
import SecuriteSociale from './src/SecuriteSociale';
import CustomerExpMetric from './src/CustomerExpMetric';
import Adresse from './src/Adresse';
import Civilite from './src/Civilite';
import File from './src/File';
import MultipleFiles from './src/MultipleFiles';
import BlocHTML from './src/BlocHTML.js';
import BlocHTMLsimple from './src/BlocHTMLsimple';
import Textarea from './src/Textarea';
import Checkbox from './src/Checkbox';
import Phone from './src/Phone';
import Recap from './src/Recap';
import Radio from './src/Radio';
import PrixProduits from './src/PrixProduits';

export default {
  Input,
  BlocHTML,
  Select,
  DateInput,
  Iban,
  Adresse,
  Civilite,
  File,
  MultiSelect,
  Checkbox,
  Phone,
  Recap,
  InputNumber,
  EAN,
  SecuriteSociale,
  CustomerExpMetric,
  Radio,
  PrixProduits,
  MultipleFiles,
  BlocHTMLsimple,
  Textarea
};
